/**
 * Centralized environment detection utilities.
 * Single source of truth for hostname checks and auth bypass logic
 * used by AuthProvider, ProtectedRoute, and TenantContext.
 */

/** Returns true when running on localhost or 127.0.0.1. */
export function isLocalDev(): boolean {
  return (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  );
}

/** Returns true when running in a deployed environment (not localhost). */
export function isDeployedEnv(): boolean {
  return !isLocalDev();
}

/** Returns true when auth bypass is enabled AND we're in a local dev environment. */
export function isAuthBypassActive(): boolean {
  if (!isLocalDev()) return false;

  const bypassEnabled =
    (import.meta as any).env?.VITE_TEST_BYPASS_AUTH === '1' ||
    (() => {
      try {
        return localStorage.getItem('TEST_BYPASS_AUTH') === '1';
      } catch {
        return false;
      }
    })();

  return bypassEnabled;
}
